/**
 * Multicolumn — clean entrance reveal (no leftover transform / will-change)
 */
(function () {
  function initReveal(root) {
    const scope = root || document;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('[data-multicolumn-enhance]').forEach((section) => {
      if (section.dataset.multicolumnRevealBound) return;
      section.dataset.multicolumnRevealBound = '1';

      const items = Array.from(section.querySelectorAll('[data-multicolumn-reveal-item]'));
      if (!items.length) return;

      if (reducedMotion) {
        items.forEach((item) => item.classList.add('is-reveal-done'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const item = entry.target;
            obs.unobserve(item);

            const onEnd = (event) => {
              if (event.target !== item || event.propertyName !== 'transform') return;
              item.removeEventListener('transitionend', onEnd);
              item.classList.add('is-reveal-done');
              item.classList.remove('is-revealed');
            };

            item.addEventListener('transitionend', onEnd);
            requestAnimationFrame(() => {
              item.classList.add('is-revealed');
            });
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    });
  }

  document.addEventListener('DOMContentLoaded', () => initReveal());
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-multicolumn-enhance]') || event.target;
    if (section && section.hasAttribute && section.hasAttribute('data-multicolumn-enhance')) {
      delete section.dataset.multicolumnRevealBound;
    }
    initReveal(event.target);
  });
})();
